;(function () {
  'use strict'

  angular.module('contrast.tsv.onboard').constant('TSV_TYPES', {
    GOOGLE: 'GOOGLE',
    EMAIL: 'EMAIL'
  })
})()
